import LocationCode from "./constants/LocationCode";
import {getDateString, phoneNumberWithHyphen} from "./Utils";
import Gender from "./constants/Gender";
import TeacherConstant from "./constants/TeacherConstant";

let TeacherDetailsInfo = {
    detailLabel: ["번호", "이름", "근무 지점", "성별", "이메일", "생년월일",
        "연락처", "로그인 아이디", "전공", "등록일", "주소", "근무일"],
    detailDataName: ["teacherid", "name", "location", "gender", "email", "birth",
        "contact", "loginid", "major", "registration", "address", "working_days"],
    getInputName: function (s) {
        return "teacher-details-" + s
    },
    getInvalidMessageId: function (s) {
        return "teacher-details-invalid-" + s
    },
    getDataText: (dataName, data) => {
        switch (dataName) {
            case "location":
                return LocationCode.text[data];
            case "gender":
                return data ? Gender.text[1] : Gender.text[0]
            case "birth":
            case "registration":
                return getDateString(new Date(data))
            case "contact":
                return phoneNumberWithHyphen(data)
            case "major":
                return TeacherConstant.major_text[data];
            case "working_days":
                return "주 " + data + "일";
            default:
                return data;
        }
    },
    editableInputs: ["location", "gender", "name", "email", "birth",
        "contact", "loginid", "major", "address", "working_days"],
    editableTextInputs: ["name", "email", "contact", "loginid", "address", "working_days"],
    editableTextLimits: [6, 38, 12, 40, 85, 1],
    editableTextRegex: [".+", "[\\w.]+@[\\w]+\\.[\\w]+", "[0-9]+", "\\w+", ".+", "[0-9]"],
    editableTextInvalid: ["NO_INPUT", "INVALID_EMAIL", "INVALID_PHONE", "INVALID_LOGINID", "NO_INPUT", "INVALID_NUMBER"],
    editableRadioInputs: ["location", "gender", "major"],
    invalidMessages: {
        INVALID_DATE: "올바르지 않은 날짜입니다.",
        NO_INPUT: "입력되지 않았습니다",
        NOT_CHECKED: "선택되지 않았습니다.",
        INVALID_PHONE: "하이픈(-) 제외 숫자만 입력하세요.",
        INVALID_LOGINID: "영어, 숫자만 가능합니다.",
        INVALID_NUMBER: "숫자만 입력하세요.",
        INVALID_EMAIL: "잘못된 이메일 형식입니다.",
        PASSWORD_NOT_MATCHES: "패스워드가 일치하지 않습니다.",
        INVALID_PASSWORD: "패스워드는 4자리 이상이어야 합니다."
    },

    registerInputs: ["name", "location", "gender", "email", "birth", "contact", "loginid", "password", "password_confirm", "major",
        "address", "working_days", "registration"],
    registerInputLabels: ["이름", "근무 지점", "성별", "이메일", "생년월일", "연락처", "로그인 아이디", "비밀번호", "비밀번호 확인", "전공",
        "주소", "근무일", "입사일"],
    registerTextInputs: ["name", "email", "contact", "loginid", "password", "password_confirm", "address", "working_days"],
    registerTextInputLimits: [6, 38, 12, 40, 25, 25, 85, 1],
    registerTextRegex: [".+", "[\\w.]+@[\\w]+\\.[\\w]+", "[0-9]+", "\\w+", ".{4,}", "", ".+", "[0-9]"],
    registerRadioInputs: ["location", "gender", "major"],
    registerInvalid: ["NO_INPUT", "NOT_CHECKED", "NOT_CHECKED", "INVALID_EMAIL", "INVALID_DATE", "INVALID_NUMBER", "INVALID_LOGINID",
        "INVALID_PASSWORD", "PASSWORD_NOT_MATCHES", "NOT_CHECKED", "NO_INPUT", "INVALID_NUMBER", "INVALID_DATE"]
}
export default TeacherDetailsInfo